export class OriginalData {
  constructor(row, mapping, selected) {
    this.hasErrors = false;
    this.selected = selected;
    this.mapping = mapping;
    this.data = { ...row };
    this.columns_with_errors = {};
  }
}
